var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDinersLogoreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    fill: "#ebf1f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.319 8.021V8h5.263v.021C22.707 8.327 25.9 11.808 25.9 16s-3.193 7.673-7.318 7.979V24h-5.263v-.021C9.193 23.673 6 20.192 6 16s3.193-7.673 7.319-7.979z",
    fill: "#0165ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.474 20.523c1.888-.68 3.15-2.492 3.15-4.523s-1.262-3.842-3.15-4.523zm-3.158-9.046c-1.889.68-3.15 2.492-3.15 4.523s1.261 3.842 3.15 4.523zm1.579 11.456c-3.78 0-6.842-3.104-6.842-6.933 0-3.83 3.063-6.933 6.842-6.933 3.779 0 6.842 3.104 6.842 6.933 0 3.83-3.063 6.933-6.842 6.933z",
    fill: "#fff"
  })))));
}
export default SvgDinersLogoreact;